import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'py-5'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_6b64d89c-5fb6-4989-a00f-bea76b519dd7/artifacts/zdtymixg_icon-mazpcc-NEG-%23ff0062.png" 
              alt="União Confraria" 
              className="h-10 w-10 sm:h-12 sm:w-12"
            />
            <div>
              <h1 className="text-lg sm:text-xl font-bold gradient-text">União Confraria</h1>
              <p className="text-xs text-muted-foreground hidden sm:block">Comunidade Descentralizada</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <a href="#happening" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Acontecendo Agora
            </a>
            <a href="#gamification" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Gamificação
            </a>
            <a href="#team" className="text-sm font-medium text-foreground hover:text-primary transition-colors">
              Equipe
            </a>
            <Button 
              size="sm" 
              className="bg-primary hover:bg-primary-glow text-primary-foreground glow-hover"
              onClick={() => window.open('https://ai.eco.br/plans/1956939?bundle_token=98b0c0c2a2973b00d7c39ae8a2114a1a&utm_source=manual', '_blank')}
            >
              Assinar Agora
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-foreground"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden mt-4 glass rounded-lg p-4 space-y-3"
          >
            <a href="#happening" className="block text-sm font-medium text-foreground hover:text-primary transition-colors py-2">
              Acontecendo Agora
            </a>
            <a href="#gamification" className="block text-sm font-medium text-foreground hover:text-primary transition-colors py-2">
              Gamificação
            </a>
            <a href="#team" className="block text-sm font-medium text-foreground hover:text-primary transition-colors py-2">
              Equipe
            </a>
            <Button 
              className="w-full bg-primary hover:bg-primary-glow text-primary-foreground"
              onClick={() => window.open('https://ai.eco.br/plans/1956939?bundle_token=98b0c0c2a2973b00d7c39ae8a2114a1a&utm_source=manual', '_blank')}
            >
              Assinar Agora
            </Button>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navigation;